import {Account, AccountPopoverFooter, SignOutButton} from "@toolpad/core";
import {Stack} from "@mui/material";
import AccountSwitch from "./AccountSwitch.tsx";

function AccountPopover() {

    return (
        <Stack direction="column" sx={{minWidth: 200}}>
            <AccountSwitch />
            <AccountPopoverFooter>
                <SignOutButton />
            </AccountPopoverFooter>
        </Stack>
    );
}

export default function EventerConsoleAccount() {

    return (
        <Account
            slots={{
                // preview: PreviewComponent,
                popoverContent: AccountPopover,
            }}
        />
    )
}